import React from "react";
import { Input, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./styles.scss";

const InputSearchComponent = ({
  name,
  label,
  placeholder = "Search...",
  required = false,
  disabled = false,
  loading = false,
  allowClear = true,
  onSearch,
  style = {},
  rules = [],
  initialValue,
  onChange,
  className = "",
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        {
          required: required,
          message: `Please enter ${label}`,
        },
        ...rules,
      ]}
      initialValue={initialValue}
    >
      <Input.Search
        placeholder={placeholder}
        className={`master-search-input ${className}`}
        disabled={disabled}
        loading={loading}
        allowClear={allowClear}
        onSearch={onSearch}
        style={style}
        onChange={onChange}
        enterButton={<SearchOutlined />}
      />
    </Form.Item>
  );
};

export default InputSearchComponent; 
